<template>
  <div id="order-popup">
    <order-invoice v-if="orderDetail.invoice" :config="invoiceConfig" :order="orderDetail"></order-invoice>
    <vs-popup
      fullscreen
      title="Order Detail"
      class="order-detail-popup"
      :active.sync="config.isActive"
      :key="config.orderId"
    >
      <div v-if="orderDetail">
        <div class="w-full flex justify-end pb-3">
          <vs-button
            v-show="order_status != ORDER_STATUS_PICKED_UP && order_status != ORDER_STATUS_COMPLETED"
            color="primary"
            @click="updateOrderStatus"
            class="mt-2"
          >{{getStatusTextForButton(getNextStatus(order_status))}}</vs-button>
        </div>
        <p
          class="w-full flex justify-end pb-6 text-sm"
          v-if="order_status == ORDER_STATUS_CONFIRM"
        >Customer will get an SMS that the order is ready to pick up</p>
        <p
          class="w-full flex justify-end pb-6 text-sm"
          v-if="order_status == ORDER_STATUS_READY"
        >Press this when your customers picked up the order</p>
        <div
          class="w-full py-base position-relative"
          style="background-color: #ebedef; max-width: 'none'"
        >
          <!-- <div class="w-full flex justify-end pb-6" style="position: absolute; right: 0; top: 0">
            <vs-button>Confirm</vs-button>
          </div>-->
          <div class="header-content">
            <h4 class="font-bold mb-4 pt-0">
              Online Store #{{orderDetail.order_code}}
              <span
                class="d-inline-block ml-2"
                :style="`color: ${getStatusColor(order_status)}`"
              >{{getStatusText(order_status)}}</span>
            </h4>
            <div class="user-info">
              <!-- User info -->
              <div class="left-info">
                <p class="font-bold mb-1">Order details</p>
                <div class="text-sm">
                  <p class="mb-1">
                    <span v-if="orderDetail.order_items">{{orderDetail.order_items.length}}</span>
                    <span v-else>0</span>
                    items (Pickup)
                  </p>
                  <p class="mb-1">Placed {{formatDate(orderDetail.created_at)}}</p>
                  <p class="mb-1">{{orderDetail.customer_name}}</p>
                  <p class="mb-1">{{orderDetail.customer_email}}</p>
                  <p class="mb-1"></p>
                </div>
              </div>
              <div class="right-info">
                <p class="font-bold mb-1">Pickup details</p>
                <div class="text-sm">
                  <p class="mb-1">{{orderDetail.customer_name}}</p>
                  <p class="mb-1">Pickup {{formatDate(orderDetail.expected_end_time)}}</p>
                  <p class="mb-1">{{StringHelper.phoneNumberFormat(orderDetail.customer_phone)}}</p>
                  <!-- <p class="mb-1">{{detail.customer_address}}</p> -->
                </div>
              </div>
            </div>
            <div class="user-info mt-2">
              <div class="left-info">
                <p class="font-bold mb-1">Payment details</p>
                <div
                  class="text-sm mb-1"
                  v-if="orderDetail.payment_method == 'cash' && orderDetail.payment == null"
                >Method: Cash</div>
                <div
                  class="text-sm"
                  v-if="orderDetail.payment_method == 'credit_card' && orderDetail.payment != null"
                >
                  <p class="mb-1">Method: Credit card</p>
                  <p class="mb-1">Amount: ${{parseFloat(orderDetail.payment.amount/100)}}</p>
                  <div class="mb-1 flex align-center">Payment status: 
                    <vs-chip
                      :color="getPaymentStatusColor(orderDetail.payment.status)" class="payment-chip-status"
                    >{{getPaymentStatus(orderDetail.payment.status)}}</vs-chip>
                  </div>
                  <!-- <p class="mb-1">
                    <vs-chip
                      :color="getPaymentStatusColor(orderDetail.payment.status)"
                    >{{getPaymentStatus(orderDetail.payment.status)}}</vs-chip>
                  </p> -->
                  <p class="mb-1">Pay at {{formatDate(orderDetail.payment.created_at)}}</p>
                </div>
              </div>
              <div class="right-info" v-if="orderDetail.order_status == ORDER_STATUS_COMPLETED">
                <p class="font-bold mb-1">Invoice details</p>
                <div class="text-sm">
                  <p @click="openInvoice" class="text-primary cursor-pointer">Click here to view invoice</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="overflow-x-auto order-content">
          <div class="order-items">
            <label class="text-lg font-bold py-6 mt-2 d-inline-block">Order Items</label>
            <vs-row class="border-bottom-custom">
              <vs-col vs-w="6" class="p-2 bg-custom">Item</vs-col>
              <!-- <vs-col vs-w="2" class="p-2 bg-custom">Note</vs-col> -->
              <vs-col vs-w="1" class="p-2 bg-custom">Qty</vs-col>
              <vs-col vs-w="2" class="p-2 bg-custom text-right">Amount</vs-col>
              <vs-col vs-w="3" class="p-2 bg-custom text-center">Action</vs-col>
            </vs-row>
            <div v-if="orderDetail.order_items" style="position: relative">
              <vs-row
                class="border-bottom-custom"
                v-for="(item, index) in orderDetail.order_items"
                :key="index"
              >
                <vs-col vs-w="6" class="p-2 flex" :class="{'cancelled-item': item.status == 99}">
                  <!-- <vs-avatar v-if="item && item.item_image" class="border-2 border-solid border-grey con-vs-avatar m-0 text-6xl pick-avatar rounded-item item-image" size="55px" :src="item.item_image"></vs-avatar>
                  <vs-avatar v-else class="border-2 border-solid border-grey con-vs-avatar m-0 text-6xl pick-avatar rounded-item item-image" size="55px" :src="item_image"></vs-avatar>-->
                  <div
                    v-if="item.item_image != null"
                    class="rounded-item item-img"
                    style="height: 51px; width: 51px; background-size: cover; background-position: center; border: 1px solid #bfbfbf"
                    :style="`background-image: url('${item.item_image}')`"
                  ></div>
                  <div
                    v-else
                    class="rounded-item item-img"
                    style="height: 51px; width: 51px; background-size: cover; background-position: center; border: 1px solid #bfbfbf"
                    :style="`background-image: url('${default_image}')`"
                  ></div>
                  <div class="ml-3" style="width: calc(100% - 62px);">
                    <p class="font-extrabold text-lg">{{item.item_name}}</p>
                    <div class="text-grey-custom text-sm">
                      <span
                        v-if="item.item_variant && item.item_variant.name"
                      >{{item.item_variant.name}}, </span>
                      <!-- <span v-if="item.item_modifier && item.item_modifier.length > 0">, </span> -->
                      <span v-for="(mod, i) in item.item_modifier" :key="i">
                        <!-- <span v-if="i != 0">, </span> -->
                        <span v-if="mod.details && mod.details.length > 0">
                          <span class="font-bold">{{mod.modifier_name}}: </span>
                          <span v-for="(detail, j) in mod.details" :key="j">
                            <!-- <span v-if="j != 0">, {{detail.name}}</span> -->
                            <!-- <span v-else>{{detail.name}}</span> -->
                            <span>{{detail.name}}, </span>
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                </vs-col>
                <!-- <vs-col vs-w="2" class="p-2 item-col" :class="{'cancelled-item': item.status == 99}">
                  <vs-input v-model="item.note" disabled></vs-input>
                </vs-col> -->
                <vs-col vs-w="1" class="p-2 item-col" :class="{'cancelled-item': item.status == 99}">
                  <!-- <div style="height: 61px; padding: 9px 0">{{item.quantity}}</div> -->
                  <div>
                    <vs-input
                      disabled
                      v-model="item.quantity"
                      class="w-full"
                      v-on:keypress="isNumber($event)"
                    ></vs-input>
                  </div>
                </vs-col>
                <vs-col vs-w="2" class="p-2 item-col justify-end" :class="{'cancelled-item': item.status == 99}">
                  <!-- <div style="height: 61px; padding: 9px 0">${{parseFloat(item.price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</div> -->
                  <div>${{parseFloat(item.price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</div>
                </vs-col>
                <vs-col vs-w="3" class="p-2 item-col justify-center action-col" v-if="order_status !=6" :class="{'cancelled-item': item.status == 99}">
                  <div
                    v-if="item.status == 1 && isEditable == true"
                    class="p-2 item-col justify-center"
                  >
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-edit"
                      color="success"
                      class="align-center mr-2"
                      @click="editItem(item)"
                    ></vs-button>
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-trash"
                      color="danger"
                      @click="giveReason(item)"
                    ></vs-button>
                  </div>
                  <div v-if="item.status == 99" class="item-col justify-center">
                    <vs-alert
                      active="true"
                      color="danger"
                      icon-pack="feather"
                      icon="icon-delete"
                      style="height: 32px; display: flex; align-items: center; line-height: unset"
                    >
                      <span style="font-size: 12px;">Cancelled</span>
                    </vs-alert>
                  </div>
                </vs-col>
              </vs-row>
            </div>

            <vs-row>
              <vs-col vs-w="6" class="pl-2 p-3">
                <!-- <vs-button color="success">
                  <feather-icon icon="PlusIcon" svgClasses="h-4 w-4 mr-1" />
                </vs-button>-->
                <div v-if="orderDetail.note" class="text-sm text-danger pb-3 break-word"><span class="font-bold">** Note: </span>{{orderDetail.note}}</div>
                <vs-button
                  v-if="order_status !=6 && isEditable == true"
                  type="border"
                  size="small"
                  icon-pack="feather"
                  icon="icon-plus"
                  color="success"
                  class="align-center mr-2 text-base"
                  @click="addItemConfig.isActive = true"
                >Add more item</vs-button>
                <popup-item-list-to-add :config="addItemConfig" @AddItemToOrder="addItemToOrder"></popup-item-list-to-add>
              </vs-col>
              <vs-col vs-w="6">
                <div class="w-full flex align-center justify-between border-bottom-custom p-2">
                  <div>Subtotal</div>
                  <div
                    class="w-1/3 ml-2 text-right"
                    style="padding-left: 18px"
                    v-if="orderDetail.total_before_discount"
                  >${{orderDetail.total_before_discount.toFixed(2)}}</div>
                  <div class="w-1/3 ml-2 text-right" style="padding-left: 18px" v-else>$0.00</div>
                </div>
                <div
                  class="font-bold w-full flex align-center justify-between border-bottom-custom p-2"
                >
                  <div>Total</div>
                  <div
                    class="w-1/3 ml-2 text-right"
                    style="padding-left: 18px"
                    v-if="orderDetail.total_after_discount"
                  >${{orderDetail.total_after_discount.toFixed(2)}}</div>
                  <div class="w-1/3 ml-2 text-right" style="padding-left: 18px" v-else>$0.00</div>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </div>
        <!-- </div>
        </div>-->
      </div>
    </vs-popup>
    <div v-if="edit_key == 1">
      <edit-item-order
        :popupEditItem="popupEditItem"
        @EditItem="editItemOrder"
        :itemData="itemData"
        :itemVariant="itemVariant"
        :itemModifier="itemModifier"
        :key="itemData.id"
      ></edit-item-order>
    </div>
    <vs-popup class="holamundo delete-popup" title="Delete Item" :active.sync="popupActive">
      <div class="text-center">
        <h4>Give us a reason for your cancellation!</h4>
        <vs-textarea class="mt-4" v-model="cancel_reason" required></vs-textarea>
        <div class="flex flex-wrap justify-center align-center p-6">
          <vs-button class="mr-6 align-center delete-responsive" @click.native="deleteItem">Delete</vs-button>
          <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupActive=false">Cancel</vs-button>
        </div>
      </div>
    </vs-popup>
    
  </div>
</template>

<script>
// import data from "./order_detail";
// import { Order } from "../../models/order/order";
import moment from "moment";
import { StringHelper } from "../../models/string_helper";
import PopupItemListToAdd from "./PopupItemListToAdd.vue";

export default {
  name: "order-order-detail",
  components: {
    "popup-item-list-to-add": PopupItemListToAdd
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    currentPage: {
      type: Number,
      required: true,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      required: true,
      default: 10
    }
  },
  data() {
    let order_status = 6;
    // let detail_key = 0;
    let orderDetailTemp = {};
    if (this.config && this.config.orderId) {
      this.$store
        .dispatch("order/ORDER_DETAIL", { id: this.config.orderId })
        .then(() => {
          this.order_status = this.orderDetail.order_status;
          // detail_key++;
          this.orderDetailTemp = JSON.parse(
            JSON.stringify(this.$store.getters["order/orderDetail"])
          );
          if (this.orderDetailTemp.order_items) {
            for (let i = 0; i < this.orderDetailTemp.order_items.length; i++) {
              this.orderDetailTemp.order_items[i].key = this.getKey(
                this.orderDetailTemp.order_items[i]
              );
            }
          }
        });
    }
    // let detail = new Order(data);
    return {
      // detail: detail,
      StringHelper,
      order_status,
      // detail_key,
      // order_status: 0,
      default_image:
        "https://www.mbrsg.ae/MBRSG/media/Images/no-image-icon-6.png",
      ORDER_STATUS_CANCEL: 99,
      ORDER_STATUS_NEW: 0,
      ORDER_STATUS_CONFIRM: 1,
      ORDER_STATUS_IN_PROGRESS: 2,
      ORDER_STATUS_READY: 3,
      ORDER_STATUS_PICKED_UP: 4,
      ORDER_STATUS_DELIVERED: 5,
      ORDER_STATUS_COMPLETED: 6,
      popupEditItem: {
        isActive: false
      },
      itemData: {},
      itemVariant: [],
      itemModifier: [],
      popupActive: false,
      cancel_reason: "Out Of Stock!",
      cancelItem: {},
      addItemConfig: {
        isActive: false
      },
      orderDetailTemp,
      edit_key: 0,
      invoiceConfig: {
        isOpen: false
      }
    };
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        if (this.config.isActive) {
          document.body.classList.add("overflow-hidden");
        } else {
          document.body.classList.remove("overflow-hidden");
        }
      }
    },
    popupActive: {
      immediate: true,
      handler() {
        if (this.popupActive == false) {
          this.cancel_reason = "Out Of Stock!";
        }
      }
    },
    orderDetail: {
      immediate: true,
      deep: true,
      handler() {
        if (this.orderDetail) {
          this.orderDetailTemp = JSON.parse(
            JSON.stringify(this.$store.getters["order/orderDetail"])
          );
          // console.log(this.orderDetailTemp)
          if (this.orderDetailTemp.order_items) {
            for (let i = 0; i < this.orderDetailTemp.order_items.length; i++) {
              this.orderDetailTemp.order_items[i].key = this.getKey(
                this.orderDetailTemp.order_items[i]
              );
            }
          }
        }
      }
    }
  },
  methods: {
    editItemOrder(data) {
      const obj = {
        order_id: this.orderDetail.id,
        order_item: data,
        page: this.currentPage,
        'per-page': this.itemsPerPage
      };
      // console.log(obj);
      this.$store
        .dispatch("order/UPDATE_ITEM", obj)
        .then(() => {
          this.$vs.notify({
            title: "Notification",
            text: "Update Item Success",
            color: "success",
            position: "top-right"
          });
        })
        .catch(() => {
          this.$vs.notify({
            title: "Notification",
            text: "Update Item Failed",
            color: "danger",
            position: "top-right"
          });
        });
      this.popupEditItem.isActive = false;
    },
    giveReason(item) {
      this.popupActive = true;
      this.cancelItem = item;
    },
    deleteItem() {
      const obj = {
        order_id: this.cancelItem.order_id,
        id: this.cancelItem.id,
        cancel_reason: this.cancel_reason,
        page: this.currentPage,
        'per-page': this.itemsPerPage
      };
      this.$store
        .dispatch("order/CANCEL_ITEM", obj)
        .then(() => {
          this.$vs.notify({
            title: "Notification",
            text: "Delete Item Success",
            color: "success",
            position: "top-right"
          });
          this.popupActive = false;
        })
        .catch(err => {
          this.$vs.notify({
            title: "Notification",
            text: err.cancel_reason[0],
            color: "danger",
            position: "top-right"
          });
        });
      // this.popupActive = false;
    },
    editItem(item) {
      let itemDetail = {};
      this.popupEditItem.isActive = true;
      this.itemData = item;
      this.$store
        .dispatch("order/ITEM_DETAIL", { id: item.item_id })
        .then(() => {
          itemDetail = this.$store.getters["order/itemDetail"];
          if (itemDetail) {
            this.itemVariant = itemDetail.item_variants;
            this.itemModifier = itemDetail.modifier;
            this.edit_key = 1;
          }
        });
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    formatDate(date) {
      return (
        moment(date).format("MMM. DD, YYYY") +
        " at " +
        moment(date).format("hh:mm A")
      );
    },
    getNextStatus(status) {
      if (status == this.ORDER_STATUS_NEW) {
        return this.ORDER_STATUS_CONFIRM;
      } else if (status == this.ORDER_STATUS_CONFIRM) {
        return this.ORDER_STATUS_READY;
      } else if (status == this.ORDER_STATUS_READY) {
        return this.ORDER_STATUS_COMPLETED;
      } else {
        return this.ORDER_STATUS_COMPLETED;
      }
    },
    getStatusColor(status) {
      if (status == this.ORDER_STATUS_NEW) {
        return "red";
      } else if (status == this.ORDER_STATUS_CONFIRM) {
        return "green";
      } else if (status == this.ORDER_STATUS_READY) {
        return "blue";
      } else if (status == this.ORDER_STATUS_PICKED_UP) {
        return "grey";
      } else {
        ("grey");
      }
    },
    getStatusText(status) {
      if (status == this.ORDER_STATUS_NEW) {
        return "New";
      } else if (status == this.ORDER_STATUS_CONFIRM) {
        return "In progress";
      } else if (status == this.ORDER_STATUS_READY) {
        return "Ready";
      } else {
        return "Finish";
      }
    },
    getStatusTextForButton(status) {
      if (status == this.ORDER_STATUS_CONFIRM) {
        return "Mark as In Progress";
      } else if (status == this.ORDER_STATUS_READY) {
        return "Mark as Ready";
      } else if (status == this.ORDER_STATUS_PICKED_UP) {
        return "Mark as Pickup";
      } else {
        return "Mark as Finish";
      }
    },
    updateOrderStatus() {
      // this.order_status = this.getNextStatus(this.order_status);
      let obj = {
        status: this.getNextStatus(this.order_status),
        // status: 0,
        id: this.orderDetail.id,
        page: 1,
        'per-page': this.itemsPerPage
      };
      this.$store.dispatch("order/ORDER_UPDATE_STATUS", obj).then(() => {
        this.order_status = this.getNextStatus(this.order_status);
        this.$emit('ChangeToFirstPage');
        // this.$vs.notify({
        //   title: "Update status",
        //   text: "Order status has been updated!",
        //   color: "success",
        //   position: "bottom-right"
        // });
        // this.detail_key++;
      });
    },
    getKey(item) {
      let str = "";
      if (item) {
        str += item.status;

        let variant =
          item.item_variant && item.item_variant.length > 0
            ? item.item_variant[0]
            : item.item_variant;
        str += variant.id;

        let modifier = item.item_modifier;
        for (let i = 0; i < modifier.length; i++) {
          let mod = modifier[i];
          // if (mod.valueNum > 0) {
          //     if (mod.type == 'single') {
          //         str += mod.value.id;
          //     } else {
          //         for (let j = 0; j < mod.value.length; j++) {
          //             str += mod.value[j].id;
          //         }
          //     }
          // }
          for (let j = 0; j < mod.details.length; j++) {
            str += mod.details[j].id;
          }
        }
      }
      return str;
    },
    addItemToOrder(item) {
      item.status = 1;
      let item_key = this.getKey(item);
      // console.log(item);
      let same_key = false;
      if (this.orderDetailTemp && this.orderDetailTemp.order_items) {
        for (let i = 0; i < this.orderDetailTemp.order_items.length; i++) {
          if (item_key == this.orderDetailTemp.order_items[i].key) {
            same_key = true;
            item.id = this.orderDetail.order_items[i].id;
            item.quantity += this.orderDetail.order_items[i].quantity;
            this.editItemOrder(item);
            this.addItemConfig.isActive = false;
            return;
          }
        }

        if (same_key == false) {
          const obj = {
            order_id: this.orderDetail.id,
            order_item: item,
            page: this.currentPage,
            'per-page': this.itemsPerPage
          };
          // console.log(obj)
          this.$store.dispatch("order/ADD_ITEM", obj);
        }
      }
      this.addItemConfig.isActive = false;
    },
    getPaymentStatus(status) {
      if (status == "succeeded") {
        return "Success";
      } else if (status == "processing") {
        return "Processing";
      } else return "Fail";
    },
    getPaymentStatusColor(status) {
      if (status == "succeeded") {
        return "success";
      } else if (status == "processing") {
        return "blue";
      } else return "danger";
    },
    openInvoice() {
      if (this.orderDetail.invoice != null){
        this.invoiceConfig.isOpen = true;
      }
    }
  },
  computed: {
    orderDetail() {
      return this.$store.getters["order/orderDetail"];
    },
    isEditable() {
      if (
        this.orderDetail.payment_method == "credit_card" &&
        this.orderDetail.payment != null &&
        this.orderDetail.payment.status == "succeeded"
      ) {
        return false;
      }
      return true;
    }
  }
};
</script>